import { useSelector } from 'react-redux';

import useCurrencyFormatter from '@swf/core/hooks/useCurrencyFormatter';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';

import {
  TXTWCL_N0_Free_Bet,
  TXTWCL_N0_Free_Bets,
  TXTWCL_N0_Promotions_Available
} from './useGetExtraWalletsAriaLabels.messages.json';

interface PromotionCashAriaLabels {
  freeBetsLabel: string;
  promotionsAvailableLabel: string;
}

export const useGetExtraWalletsAriaLabels = (): PromotionCashAriaLabels => {
  const { formatMessage } = useRegulatoryIntl();
  const formatAsCurrency = useCurrencyFormatter();

  const allWallets = useSelector(select.extraWallets.getAllEnabledWallets);
  const freeBetsWallets = useSelector(select.extraWallets.getFreeBetsWallets);
  const totalFreeBetsBalance = useSelector(select.extraWallets.getTotalFreeBetsBalance);

  const currencyLabel = formatAsCurrency({ value: totalFreeBetsBalance, cents: false });

  const freeBetsLabel = formatMessage(
    freeBetsWallets.length === 1 ? TXTWCL_N0_Free_Bet : TXTWCL_N0_Free_Bets,
    {
      0: currencyLabel
    }
  );

  const promotionsAvailableLabel = formatMessage(TXTWCL_N0_Promotions_Available, {
    0: allWallets.length
  });

  return { freeBetsLabel, promotionsAvailableLabel };
};
